<template lang="pug">
  #app
    router-view
    .footer
      Footer

</template>

<script>
import router from '@/router'
import Footer from '@/components/Footer'

export default {
  name: 'app',
  router,
  components: {
    Footer
  }
}
</script>

<style lang="stylus">
  @import "./styles/main.styl"

  #app {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #262626;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

</style>
